export enum YesNoAnswer {
	YES = 'Yes',
	NO = 'No',
}

export const rescheduleOptions = [
	{ value: true, label: YesNoAnswer.YES },
	{ value: false, label: YesNoAnswer.NO },
];
